import dayjs from 'dayjs'
import type { State } from './types'

export const buildStateFromSearchParams = (
  searchParams: URLSearchParams
): {
  pagination: State['pagination']
} => {
  const pagination: State['pagination'] = {
    currentPage: Number(searchParams.get('page')) || 0,
    pageSize: Number(searchParams.get('page-size')) || 10
  }

  return {
    pagination
  }
}

interface RawSearchParam {
  value: unknown
  name: string
  convert?: (value: unknown) => unknown
}

export const buildSearchParams = (rawSearchParams: RawSearchParam[]): URLSearchParams => {
  const searchParams = new URLSearchParams()

  for (const rawSearchParam of rawSearchParams) {
    if (Array.isArray(rawSearchParam.value) && rawSearchParam.value.length === 0) {
      searchParams.delete(rawSearchParam.name)
      continue
    }

    if (rawSearchParam.value === undefined) {
      searchParams.delete(rawSearchParam.name)
      continue
    }

    if (typeof rawSearchParam.value === 'string' && rawSearchParam.value.trim() === '') {
      searchParams.delete(rawSearchParam.name)
      continue
    }

    searchParams.set(rawSearchParam.name, String(rawSearchParam.value))
  }

  return searchParams
}

export const formatDuration = (milliseconds: number, options: { short?: boolean } = {}): string => {
  const duration = dayjs.duration(milliseconds)

  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  if (!options.short) {
    const parts = []

    if (hours > 0) {
      parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`)
    }

    if (minutes > 0) {
      parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`)
    }

    if (seconds > 0) {
      parts.push(`${seconds} ${seconds === 1 ? 'second' : 'seconds'}`)
    }

    return parts.join(' ') || '0 seconds'
  }

  const parts = []

  if (hours > 0) {
    parts.push(`${hours}H`)
  }

  if (minutes > 0) {
    parts.push(`${minutes}M`)
  }

  if (seconds > 0) {
    parts.push(`${seconds}S`)
  }

  return parts.join(' ') || '0S'
}
